import type { SVGProps } from 'react'
const SvgSyAicpa = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340" width={24} height={24} {...props}>
		<defs>
			<linearGradient
				id="b"
				x1={-160.5}
				y1={385.5}
				x2={-159.5}
				y2={385.5}
				gradientTransform="translate(122281.1 -107785.9) rotate(26) scale(390.5)"
				gradientUnits="userSpaceOnUse">
				<stop offset={0} stopColor="#58b4e8" />
				<stop offset={1} stopColor="#2161ad" />
			</linearGradient>
			<linearGradient
				id="c"
				x1={-160.5}
				y1={385.5}
				x2={-159.5}
				y2={385.5}
				gradientTransform="translate(121181.5 -49842.1) rotate(45) scale(313.7)"
				gradientUnits="userSpaceOnUse">
				<stop offset={0} stopColor="#355faa" />
				<stop offset={1} stopColor="#5ab7e9" />
				<stop offset={1} stopColor="#5ab7e9" />
			</linearGradient>
		</defs>
		<circle fill="url(#b)" cx={170} cy={170} r={170} transform="translate(-70.4 170) rotate(-45)" />
		<circle fill="url(#c)" cx={170} cy={170} r={129} transform="translate(-70.4 170) rotate(-45)" />
		<path
			fill="#ffffff"
			d="M59.1,277.7c.4-.4.6-1,.5-1.6,0-.6-.4-1.5-1-2.6-.7-1.2-1.1-2.2-1.2-3,0-.8,0-1.6.8-2.3.6-.7,1.4-.9,2.4-.9,1,0,1.9.6,2.7,1.4.9.9,1.4,1.8,1.4,2.8s-.3,1.9-1,2.6l-.7-.6c.6-.6.8-1.3.8-2,0-.8-.4-1.5-1.1-2.1-.7-.7-1.4-1-2.1-1.1s-1.3.2-1.7.6c-.4.4-.6,1-.5,1.6,0,.6.4,1.5,1.1,2.6.7,1.2,1,2.2,1.1,3,0,.9-.2,1.6-.8,2.3-.7.7-1.5.9-2.4.8-1-.1-1.9-.6-2.7-1.4-.9-.8-1.4-1.8-1.6-2.8-.2-1.1,0-2,.9-2.8l.7.6c-.7.7-.9,1.4-.7,2.2.2.8.6,1.5,1.3,2.2.7.6,1.4,1,2.1,1.1s1.3,0,1.7-.6Z"
		/>
		<path
			fill="#ffffff"
			d="M70.1,284.3c-1,1.2-2.1,1.9-3.4,2.1-1.3.2-2.5-.2-3.6-1.1-1.1-.9-1.6-2-1.7-3.3,0-1.3.5-2.5,1.5-3.7l1.3-1.5c1-1.2,2.1-1.9,3.4-2.1,1.3-.2,2.4.2,3.5,1.1,1.1.9,1.7,2,1.7,3.3s-.4,2.5-1.4,3.7l-1.3,1.5ZM70.6,282.2c.8-1,1.3-2,1.3-3.1s-.4-1.9-1.3-2.7c-.9-.7-1.8-1-2.8-.8-1,.2-1.9.8-2.8,1.8l-1.3,1.5c-.8,1-1.3,2-1.3,3.1s.4,1.9,1.3,2.7c.9.8,1.9,1,2.9.9,1-.2,1.9-.8,2.8-1.8l1.2-1.6Z"
		/>
		<path
			fill="#ffffff"
			d="M78.3,291.9c-.7,1-1.6,1.6-2.6,1.7-1.1.1-2.1-.2-3.2-1-1.1-.8-1.7-1.8-1.8-3.1,0-1.3.3-2.5,1.2-3.8l1.2-1.6c.9-1.2,2-2,3.2-2.3,1.2-.3,2.4-.1,3.5.7,1.1.8,1.7,1.7,2,2.7.2,1,0,2-.7,3l-.8-.5c.6-.8.8-1.6.6-2.4-.2-.8-.7-1.5-1.5-2.1-.9-.6-1.8-.8-2.8-.5-1,.3-1.9,1-2.6,2l-1.2,1.6c-.8,1.1-1.1,2.1-1.1,3.1s.5,1.9,1.3,2.5c.8.6,1.7.9,2.5.8.8,0,1.5-.5,2.1-1.4l.7.6Z"
		/>
		<path
			fill="#ffffff"
			d="M82.7,299.2l4.2-7-1.3-.8.4-.7,1.3.8.7-1.1c.5-.8,1-1.3,1.7-1.4.7,0,1.3,0,2,.4.2,0,.3.2.4.3,0,.1.3.3.4.4l-.5.6c0,0-.2-.2-.3-.3,0,0-.2-.2-.4-.3-.5-.3-.9-.4-1.3-.2-.4,0-.8.5-1.1,1l-.7,1.1,1.7,1.1-.4.7-1.7-1.1-4.2,7-.9-.5Z"
		/>
		<path
			fill="#ffffff"
			d="M88.8,297.5c.6-1.2,1.5-1.9,2.5-2.3,1-.4,2.1-.3,3.1.3,1.1.6,1.7,1.4,1.9,2.5.2,1.1,0,2.2-.6,3.4v.2c-.7,1.2-1.6,2-2.6,2.4-1,.4-2.1.3-3.1-.3-1.1-.6-1.7-1.4-1.9-2.5-.2-1.1,0-2.2.6-3.4v-.3ZM89.6,298.2c-.5.9-.7,1.8-.6,2.7,0,.9.6,1.5,1.4,2,.8.4,1.6.5,2.4,0,.8-.4,1.5-1,1.9-1.9v-.2c.6-.9.8-1.8.6-2.7-.2-.9-.6-1.5-1.4-2-.8-.5-1.6-.5-2.4,0-.8.4-1.4,1-1.9,1.9v.2Z"
		/>
		<path
			fill="#ffffff"
			d="M103,300.8l-.6-.3c-.6-.3-1.1-.3-1.6-.2-.5,0-1,.5-1.4.9l-2.7,5.6-.9-.4,3.9-8.1.8.4-.5,1.4h0c.5-.3,1-.5,1.5-.6.5,0,1.1,0,1.6.3.1,0,.2,0,.3.2,0,.1.2.1.2.2l-.6.6Z"
		/>
		<path
			fill="#ffffff"
			d="M113.1,310.5c.2-.6.2-1.1,0-1.7-.3-.6-1-1.2-1.9-2-1.1-.8-1.8-1.6-2.3-2.3-.4-.7-.5-1.5-.2-2.4.3-.9,1-1.4,1.9-1.7.9-.3,1.9-.2,3,.2,1.1.4,2,1.1,2.4,2,.5.9.5,1.8.1,2.8l-.9-.3c.3-.7.2-1.5,0-2.2-.4-.7-1-1.2-1.8-1.5-.9-.3-1.6-.4-2.3-.2-.7.2-1.1.6-1.3,1.2-.2.6-.2,1.1.1,1.7.3.5,1,1.2,2,2,1.1.8,1.8,1.6,2.2,2.3.4.7.5,1.5.2,2.4-.3.9-1,1.4-1.9,1.7-.9.3-2,.2-3.1-.3-1.1-.4-2-1.1-2.6-2-.6-.9-.7-1.9-.3-2.9l.9.3c-.3.9-.3,1.7.2,2.3.5.7,1.2,1.2,2,1.5.9.3,1.6.4,2.3.2.8,0,1.3-.4,1.5-1.1Z"
		/>
		<path
			fill="#ffffff"
			d="M118.7,315.7c-1.1-.3-1.9-1-2.3-2-.4-1-.5-2.1,0-3.4v-.4c.5-1.2,1.2-2.1,2.1-2.7,1-.6,1.9-.7,3-.4,1,.3,1.7.9,2.1,1.8.4.8.4,1.8,0,3l-.2.7-6-1.9v.3c-.4,1-.4,1.9,0,2.7.3.8.9,1.3,1.8,1.6.5.2,1,.2,1.5.2s.9-.2,1.3-.4l.2.8c-.4.2-.9.4-1.4.4s-1.2,0-1.9-.3ZM121.2,307.5c-.7-.2-1.4-.2-2,.2-.6.4-1.1,1-1.4,1.7h0c0,0,4.9,1.6,4.9,1.6v-.2c.3-.8.3-1.5,0-2.1-.4-.5-.9-.9-1.6-1.2Z"
		/>
		<path
			fill="#ffffff"
			d="M130.3,310.2l-.7-.2c-.6-.2-1.1,0-1.6,0-.5.2-.9.6-1.2,1.2l-1.6,6-1-.2,2.3-8.7.8.2-.3,1.5h0c.4-.4.8-.7,1.3-.9.5-.2,1-.2,1.6,0,0,0,.2,0,.3,0s.2,0,.2,0v.9Z"
		/>
		<polygon
			fill="#ffffff"
			points="133.4 317 133.5 318.1 134 317.1 137.8 311 138.8 311.2 133.6 319.3 132.8 319.1 131.3 309.6 132.3 309.8 133.4 317"
		/>
		<path fill="#ffffff" d="M140,320.5l-1-.2,1.5-8.9,1,.2-1.5,8.9ZM141.9,309.1l-1-.2.2-1.4,1,.2-.2,1.4Z" />
		<path
			fill="#ffffff"
			d="M146.4,320.7c.6,0,1.2,0,1.7-.4.5-.3.8-.8.9-1.5h.9v.2c0,.8-.5,1.5-1.2,1.9-.7.5-1.6.7-2.4.5-1.2,0-2.1-.7-2.6-1.6-.5-.9-.8-2-.6-3.3v-.3c.2-1.3.6-2.3,1.4-3.1.8-.8,1.7-1.1,2.9-.9,1,0,1.7.5,2.3,1.2.6.7.8,1.5.6,2.4h-.9c0-.8,0-1.4-.5-1.9-.4-.5-1-.8-1.6-.9-.9,0-1.7,0-2.2.8-.5.6-.9,1.5-1,2.5v.3c0,1,0,1.9.4,2.7.3.9.9,1.3,1.9,1.4Z"
		/>
		<path
			fill="#ffffff"
			d="M155.5,322.4c-1.2,0-2.1-.6-2.7-1.4-.7-.9-1-1.9-.9-3.2v-.5c0-1.3.5-2.3,1.3-3.1.8-.8,1.7-1.1,2.8-1.1,1.1,0,1.9.5,2.5,1.2.5.7.8,1.7.7,2.9v.8c0,0-6.3-.4-6.3-.4v.3c0,1,0,1.9.6,2.6.5.7,1.2,1.1,2.1,1.2.5,0,1.1,0,1.5-.2.5,0,.9-.4,1.2-.6l.4.7c-.3.3-.8.6-1.3.7-.5,0-1.2.2-1.9,0ZM156,314c-.8,0-1.4.2-1.9.7-.5.5-.9,1.2-1,2h0c0,0,5.1.4,5.1.4v-.2c0-.8,0-1.5-.5-2-.3-.6-.9-.9-1.7-.9Z"
		/>
		<path
			fill="#ffffff"
			d="M174.7,317.4c0,1.6-.4,2.8-1.2,3.8-.8,1-2,1.5-3.4,1.5s-2.6-.4-3.4-1.4c-.8-1-1.3-2.2-1.4-3.8v-2c0-1.6.4-2.8,1.2-3.8.8-1,1.9-1.5,3.4-1.5s2.6.4,3.5,1.4c.9.9,1.3,2.2,1.4,3.8v2ZM173.7,315.4c0-1.3-.4-2.4-1.1-3.1s-1.6-1.2-2.8-1.1c-1.2,0-2,.4-2.7,1.3-.6.8-.9,1.9-.9,3.2v2c0,1.3.4,2.4,1,3.1.6.7,1.6,1.2,2.7,1.1,1.2,0,2.1-.4,2.7-1.3.6-.8.9-1.9.9-3.2l.2-2Z"
		/>
		<path
			fill="#ffffff"
			d="M181,313.8h-.7c-.6,0-1.1.3-1.5.7s-.6.9-.7,1.5l.5,6.2h-1c0,0-.7-8.9-.7-8.9h.9c0-.1.2,1.4.2,1.4h0c.2-.5.5-.9.9-1.3.4-.3.9-.5,1.5-.6h.7v1Z"
		/>
		<path
			fill="#ffffff"
			d="M182.7,317.4c-.2-1.4,0-2.6.5-3.5.5-.9,1.3-1.5,2.4-1.6.6,0,1.2,0,1.7.2.5.2.9.5,1.3,1v-1.4h.8c0-.1,1.2,8.9,1.2,8.9,0,1.1-.1,2.1-.6,2.8-.5.7-1.4,1.1-2.5,1.3-.4,0-.9,0-1.4,0-.5,0-.9,0-1.3-.3v-.9c.5.1.9.2,1.3.3h1.3c.9,0,1.5-.4,1.9-.9.4-.5.5-1.2.4-2.1l-.2-1.3c-.2.5-.6.9-1,1.2-.4.3-1,.5-1.6.6-1.1,0-2-.2-2.7-.9s-1.1-1.7-1.3-3.1l-.2-.3ZM183.7,317.4c0,1.1.5,1.9,1,2.5.5.6,1.2.8,2.1.7.6,0,1.1-.3,1.5-.6.4-.3.7-.8.8-1.3l-.6-4.3c-.3-.5-.7-.8-1.1-1.1-.5-.3-1-.4-1.7-.3-.9,0-1.5.6-1.8,1.3-.3.8-.4,1.7-.3,2.9v.2Z"
		/>
		<path
			fill="#ffffff"
			d="M199,319.2c0-.3-.2-.6-.3-.8-.1-.2-.1-.4-.2-.7-.2.5-.6,1-1.1,1.4-.5.4-1.1.7-1.8.8-.9.2-1.6,0-2.1-.3-.6-.4-.9-.9-1.1-1.7-.2-.8,0-1.5.7-2.1.6-.6,1.4-1,2.6-1.3l2.2-.4-.2-1.1c0-.6-.4-1.1-.9-1.4-.5-.3-1.1-.4-1.8-.2-.7,0-1.2.4-1.5.8-.3.4-.5.9-.4,1.4l-.9.2c-.2-.7,0-1.3.5-1.9.5-.6,1.2-1,2.2-1.2,1-.2,1.8,0,2.5.3.7.4,1.1,1,1.3,2l.8,4.3c0,.3,0,.6.2.9,0,.3.2.6.3.8l-1,.2ZM195.6,319.2c.8,0,1.4-.4,1.8-.9.5-.5.8-1,.9-1.6l-.3-1.7-2.2.4c-.8.2-1.4.5-1.9.9-.4.5-.6,1-.5,1.5,0,.5.3.9.7,1.1.5.3.9.4,1.5.3Z"
		/>
		<path
			fill="#ffffff"
			d="M201.5,309.5l.5,1.5c0-.6.4-1.1.8-1.5.4-.4.9-.7,1.6-.9.9-.2,1.7,0,2.4.3.6.4,1.1,1.3,1.4,2.5l1.4,5.3-1,.2-1.4-5.3c-.3-1-.6-1.7-1.1-2-.5-.3-1.1-.4-1.7-.2-.7.2-1.2.5-1.5.9-.3.4-.5,1-.6,1.6l1.6,6.2-1,.2-2.2-8.7h.8Z"
		/>
		<path fill="#ffffff" d="M210,304.4l-.9.3-.4-1.3.9-.3.4,1.3ZM213.4,315.5l-.9.3-2.6-8.6.9-.3,2.6,8.6Z" />
		<polygon
			fill="#ffffff"
			points="216.7 313.6 222.2 311.7 222.5 312.5 215.8 314.8 215.6 314.1 218.3 305.3 213.3 307 213 306.2 219.1 304 219.3 304.7 216.7 313.6"
		/>
		<path
			fill="#ffffff"
			d="M229.8,309.4c-.2-.3-.3-.5-.4-.7,0-.2-.2-.4-.3-.6,0,.6-.3,1.1-.7,1.6-.4.5-.9.9-1.6,1.2-.8.3-1.5.4-2.2,0-.6-.2-1.1-.7-1.4-1.5-.3-.7-.2-1.5.2-2.2.5-.7,1.2-1.3,2.2-1.7l2-.8-.4-1c-.2-.6-.6-1-1.1-1.2-.5-.2-1.1,0-1.8.2-.6.3-1.1.6-1.3,1.1-.3.5-.3.9,0,1.4l-.9.4c-.3-.6-.3-1.3,0-2,.4-.7,1-1.3,1.9-1.6.9-.4,1.7-.5,2.5-.2.7.2,1.3.8,1.7,1.7l1.7,4.1c0,.3.3.6.4.8,0,.3.3.5.5.8h-1ZM226.5,310.1c.7-.3,1.2-.7,1.6-1.3.4-.6.5-1.1.5-1.7l-.7-1.6-2,.9c-.7.3-1.3.7-1.6,1.3-.3.6-.4,1.1-.2,1.6.2.5.5.8.9.9.5,0,1,0,1.5,0Z"
		/>
		<path
			fill="#ffffff"
			d="M229.9,297l1,2.1,1.8-.8.3.7-1.8.8,2.5,5.3c.3.5.5.9.8,1,.3,0,.6,0,.9,0,0,0,.2,0,.3-.2,0,0,.2,0,.3-.2l.5.6c0,.1-.2.2-.4.4-.2,0-.3.2-.5.3-.6.3-1.1.3-1.6.1-.5-.2-.9-.7-1.3-1.5l-2.5-5.3-1.4.7-.3-.7,1.4-.7-1-2.1,1-.5Z"
		/>
		<path fill="#ffffff" d="M234.1,294.6l-.9.5-.6-1.2.9-.5.6,1.2ZM239.4,304.9l-.9.5-4.1-8,.9-.5,4.1,8Z" />
		<path
			fill="#ffffff"
			d="M239.4,299.7c-.7-1.2-.9-2.3-.7-3.4.2-1.1.8-1.9,1.9-2.5,1-.6,2.1-.7,3.1-.3,1,.4,1.9,1.1,2.6,2.3v.2c.8,1.2,1,2.3.8,3.4-.2,1.1-.8,1.9-1.9,2.5-1.1.6-2.1.7-3.1.3-1-.4-1.9-1.1-2.6-2.3v-.2ZM240.4,299.5c.5.9,1.2,1.5,2,1.9.8.4,1.6.3,2.4-.2.8-.5,1.3-1.1,1.4-2s0-1.8-.6-2.7v-.2c-.6-.9-1.3-1.5-2.1-1.9-.8-.4-1.6-.3-2.4.2-.8.5-1.3,1.1-1.4,2-.1.9,0,1.8.6,2.7v.2Z"
		/>
		<path
			fill="#ffffff"
			d="M246.6,290.4l.9,1.3c0-.6,0-1.2.3-1.7.2-.5.6-1,1.2-1.3.8-.5,1.6-.7,2.4-.5.8.2,1.5.9,2.2,1.9l3,4.6-.8.5-3-4.6c-.6-.9-1.1-1.4-1.7-1.5-.6,0-1.1,0-1.7.4-.6.4-1,.8-1.1,1.4-.2.5-.2,1.1,0,1.7l3.5,5.3-.8.5-4.9-7.5.5-.5Z"
		/>
		<path
			fill="#ffffff"
			d="M262,287.9c-.3-.3-.6-.5-1.1-.6-.5,0-1.1,0-2,.5-1,.5-1.8.7-2.4.7s-1.2-.3-1.6-.8c-.4-.6-.5-1.2-.3-1.9.2-.7.7-1.4,1.4-1.9.8-.6,1.6-.9,2.4-.8.8,0,1.4.4,1.8,1h0c0,0-.7.6-.7.6-.3-.4-.7-.6-1.3-.7-.6,0-1.1,0-1.7.6-.6.4-.9.9-1,1.4,0,.5,0,.9.2,1.2.2.3.6.5,1,.5s1.1-.2,1.9-.5c1-.4,1.8-.7,2.5-.6.7,0,1.2.3,1.7.9.4.6.6,1.3.4,2-.2.7-.7,1.4-1.5,2-.9.7-1.7,1-2.5.9-.8,0-1.4-.4-1.8-1h0c0,0,.7-.6.7-.6.4.5.9.7,1.5.7.6,0,1.1-.3,1.7-.7.6-.4.9-.9,1.1-1.4,0-.7-.2-1.2-.4-1.5Z"
		/>
		<polygon fill="#ffffff" points="275.1 282.8 274.4 283.5 264.8 272.8 265.5 272.1 275.1 282.8" />
		<path
			fill="#ffffff"
			d="M280.5,272c.8-.2,1.7-.7,2.4-1.4,1-1.1,1-2.3.2-3.1-.8-.7-1.7-.7-3.1,0-1.8.9-3.3,1.1-4.4,0-1.3-1.2-1.3-3.2.2-4.8.8-.9,1.6-1.3,2.1-1.5l.6,1.1c-.4,0-1.2.5-1.9,1.2-1.1,1.2-.8,2.2-.2,2.8.8.7,1.7.6,3.2-.2,1.9-.9,3.2-1,4.5.1,1.3,1.2,1.5,3.2-.3,5.2-.7.8-1.8,1.5-2.5,1.7l-.8-1.1Z"
		/>
		<path
			fill="#ffffff"
			d="M285.4,263.4c1.6,1.3,3.1.8,4-.4.7-.8.9-1.4,1.1-2l1,.5c-.2.6-.5,1.4-1.3,2.4-1.6,2-3.9,2.1-5.8.5-1.9-1.6-2.5-4-1-5.8,1.7-2.1,4-1.1,5.2-.2.2.2.4.4.5.5l-3.7,4.5ZM287.4,259.3c-.7-.6-2.1-1.2-3.2,0-1,1.2-.3,2.6.4,3.3l2.8-3.4Z"
		/>
		<path
			fill="#ffffff"
			d="M288.9,256.2c-.8-.6-1.5-1.1-2.1-1.5l.8-1,1.3.9h0c-.7-1.1-.7-2.2,0-3,0,0,.2-.2.3-.3l1.1.8c0,0-.2.2-.3.4-.6.8-.4,1.9.3,2.8,0,0,.3.3.5.5l3.5,2.6-.9,1.2-4.4-3.4Z"
		/>
		<path
			fill="#ffffff"
			d="M290.7,249.3l4.7,1.3c.8.2,1.5.4,2.1.6-.5-.5-.9-1.1-1.4-1.8l-2.9-3.9.9-1.3,5,7.3-.8,1.2-8.6-2,1-1.4Z"
		/>
		<path
			fill="#ffffff"
			d="M293.8,240.4c.4.3.6.8.3,1.3-.3.4-.8.6-1.3.3-.4-.3-.6-.8-.3-1.3.3-.5.9-.6,1.3-.3ZM301.9,247.3l-7-4.3.8-1.3,7,4.3-.8,1.3Z"
		/>
		<path
			fill="#ffffff"
			d="M306.8,238.4c0,.4-.2,1.3-.8,2.3-1.2,2.2-3.5,2.7-5.7,1.5-2.2-1.3-2.9-3.7-1.6-6,.4-.8,1-1.3,1.4-1.6l.8.9c-.4.2-.8.6-1.2,1.3-.9,1.6-.2,3.2,1.3,4.1,1.7.9,3.3.5,4.1-1,.4-.7.5-1.3.6-1.8l1.1.3Z"
		/>
		<path
			fill="#ffffff"
			d="M304.9,234.3c1.8.9,3.2,0,3.8-1.2.5-1,.6-1.6.6-2.2l1.1.3c0,.6-.2,1.5-.8,2.7-1.1,2.3-3.3,2.9-5.5,1.8-2.2-1.1-3.3-3.3-2.2-5.4,1.2-2.4,3.6-2,5-1.3.3,0,.5.3.6.4l-2.6,4.9ZM305.9,229.9c-.8-.4-2.4-.7-3.1.8-.7,1.4.3,2.6,1.1,3.1l2-3.9Z"
		/>
		<path
			fill="#ffffff"
			d="M311.7,213.9c3.7,1.4,4.8,4.4,3.7,7.2-1.1,2.8-4.1,3.9-7.3,2.7-3.4-1.3-4.8-4.3-3.7-7.2,1.1-2.9,4.1-3.9,7.3-2.7ZM308.6,222.3c2.3.9,4.8.5,5.7-1.7.9-2.2-.7-4.2-3.1-5.2-2.1-.8-4.8-.6-5.7,1.7-.9,2.3.7,4.3,3.1,5.2Z"
		/>
		<path
			fill="#ffffff"
			d="M312.4,212.1c-.9-.3-1.7-.5-2.5-.7l.4-1.2,1.6.5h0c-.9-.8-1.3-1.9-1-2.8,0-.2,0-.3.2-.4l1.3.4c0,0,0,.3-.2.5-.3,1,.2,2,1.2,2.5.2,0,.4.2.6.3l4.2,1.4-.5,1.4-5.3-1.9Z"
		/>
		<path
			fill="#ffffff"
			d="M313.5,199.3c.6.2,1.2.4,2.2.7l4.6,1.3c1.8.5,2.8,1.2,3.3,2.1.5,1,.4,2.1.2,3.2-.3,1-.8,1.9-1.4,2.5l-1-.7c.5-.4,1-1.2,1.3-2.2.4-1.5,0-2.8-2.1-3.3l-.9-.2c.6.6,1,1.7.6,2.9-.5,2-2.6,2.9-4.8,2.3-2.7-.7-3.7-2.9-3.2-4.7.4-1.4,1.3-1.9,2.1-2.1l-1.2-.4.3-1.4ZM316.2,201.6c-.2,0-.5,0-.7,0-.9,0-1.8.5-2.1,1.6-.4,1.4.5,2.7,2.4,3.2,1.6.4,3.1,0,3.5-1.6.2-.9-.1-1.8-.9-2.4-.2,0-.5-.3-.7-.3l-1.5-.4Z"
		/>
		<path
			fill="#ffffff"
			d="M323.1,194.2h-1c0,0,0,0,0,0,.5.6.9,1.6.7,2.7-.3,1.6-1.7,2.2-2.8,2-1.9-.4-2.6-2.4-2-5.5h-.2c-.7-.1-1.9-.2-2.3,1.4-.2.7-.1,1.6.2,2.2h-1c-.3-.7-.4-1.7-.2-2.7.5-2.5,2.3-2.7,3.9-2.4l3,.6c.7,0,1.4.3,2,.3l-.3,1.4ZM318.9,193.6c-.4,1.6-.5,3.5,1.1,3.8.9.2,1.5-.3,1.7-1.1.2-1-.3-1.9-.9-2.2,0-.1-.3-.1-.4-.2l-1.5-.3Z"
		/>
		<path
			fill="#ffffff"
			d="M317.9,189.3c-.8-.1-1.5-.2-2.2-.3l.2-1.3h1.4c-.7-.4-1.3-1.5-1.1-2.8.2-1.1,1.1-2.8,3.9-2.4l4.9.7-.2,1.5-4.7-.7c-1.3-.2-2.5,0-2.7,1.5,0,1,.4,1.8,1.2,2.2.2,0,.4.2.7.2l4.9.7-.2,1.5-6.1-.8Z"
		/>
		<path
			fill="#ffffff"
			d="M314.9,177.8c.5,0,.9.5.8,1,0,.5-.5.9-1,.8-.5,0-.9-.5-.8-1,0-.6.5-.9,1-.8ZM325.2,180.5l-8.2-.9.2-1.5,8.2.9-.2,1.5Z"
		/>
		<path
			fill="#ffffff"
			d="M324.7,177.1l-4.6-4.1c-.4-.4-.8-.8-1.2-1.2l-.3,4.4h-1.2c0-.1.4-6.4.4-6.4h.9c0,.1,4.5,4.1,4.5,4.1.4.4.8.7,1.2,1.1l.3-4.8h1.2c0,0-.5,6.8-.5,6.8h-.7Z"
		/>
		<path
			fill="#ffffff"
			d="M326.2,164.1h-1v.2c.6.5,1.2,1.4,1.2,2.5,0,1.7-1.2,2.5-2.4,2.5-2,0-3-1.8-3-5h-.2c-.7,0-1.9,0-1.9,1.8s.2,1.6.6,2.2l-1,.3c-.4-.7-.7-1.7-.7-2.7,0-2.5,1.8-3.1,3.4-3.1h3.1c.7,0,1.4,0,2,0v1.3ZM322,164.2c-.1,1.6.2,3.5,1.8,3.5s1.4-.6,1.5-1.4c0-1.1-.6-1.8-1.3-2-.2,0-.3,0-.5,0h-1.5Z"
		/>
		<path
			fill="#ffffff"
			d="M315.5,158.7h2.4v-2.2h1.1v2.1h4.4c1,0,1.6-.4,1.6-1.3s0-.7,0-.9h1.1c0,.2.2.6.2,1.2s-.2,1.3-.6,1.6c-.4.4-1.2.6-2.1.6h-4.5v1.4h-1.1v-1.3h-2l-.4-1.2Z"
		/>
		<path
			fill="#ffffff"
			d="M315.4,153.3c.5,0,.9.3,1,.9,0,.5-.4.9-.9,1-.5,0-1-.3-1-.9,0-.6.3-1,.9-1ZM326,154.3l-8.2.5v-1.5c0,0,8.1-.5,8.1-.5v1.5Z"
		/>
		<path
			fill="#ffffff"
			d="M320.9,143c3-.3,4.6,1.7,4.8,3.7.2,2.2-1.2,4.1-3.8,4.3-2.7.3-4.5-1.4-4.8-3.6-.3-2.4,1.3-4.1,3.8-4.4ZM321.6,149.5c1.8-.2,3-1.3,2.9-2.8-.1-1.4-1.6-2.4-3.4-2.2-1.4,0-3.1,1-2.9,2.8,0,1.8,1.8,2.4,3.4,2.2Z"
		/>
		<path
			fill="#ffffff"
			d="M318.8,141.2c-.8,0-1.5.3-2.2.4l-.2-1.3,1.3-.3c-.8-.3-1.7-1.1-2-2.4-.2-1.1.2-3,3-3.4l4.9-.8.2,1.5-4.7.8c-1.3.2-2.3.9-2.1,2.3.2,1,1,1.6,1.8,1.7h.7l4.9-.8.2,1.5-5.8.8Z"
		/>
		<path
			fill="#ffffff"
			d="M321.6,131.1c.2-.5.3-1.3.2-2.1-.2-1.1-.9-1.4-1.5-1.3-.7.2-1,.6-1.2,1.8-.2,1.6-.9,2.4-1.8,2.6-1.3.3-2.6-.5-3-2.3-.2-.8,0-1.6.1-2.1h1.1c0,.5-.3,1.1,0,1.8.2.9.8,1.2,1.4,1.1.7,0,.9-.7,1-1.8.2-1.5.8-2.4,2-2.6,1.4-.3,2.6.6,3.1,2.5.2.9.2,1.7,0,2.4h-1.2Z"
		/>
		<path
			fill="#ffffff"
			d="M110.5,129.5h-21.2l-4.9,13.5h-4.1l17.8-48.4h3.7l17.7,48.4h-4.1l-4.8-13.5ZM90.6,126h18.7l-9.2-25.7h-.2l-9.3,25.7Z"
		/>
		<rect fill="#ffffff" x={127.2} y={94.6} width={4} height={48.4} />
		<path
			fill="#ffffff"
			d="M177.3,127.9v.2c.2,4.7-1.3,8.6-4.6,11.3-3.2,2.9-7.4,4.3-12.6,4.3s-9.7-2-13-5.8c-3.3-3.8-4.9-8.9-4.9-15.1v-7.9c0-6.2,1.6-11.2,4.9-15.1,3.3-3.9,7.7-5.9,13-5.9s9.5,1.4,12.6,4.2c3.1,2.8,4.7,6.6,4.6,11.4v.2h-3.8c0-3.9-1.2-7-3.6-9.1-2.4-2.1-5.7-3.3-9.8-3.3s-7.6,1.6-10.2,4.9c-2.6,3.3-3.8,7.5-3.8,12.6v7.9c0,5.2,1.2,9.4,3.8,12.7,2.6,3.3,6,4.9,10.2,4.9s7.5-1.1,9.8-3.2c2.4-2.1,3.6-5.2,3.6-9.3h3.7Z"
		/>
		<path
			fill="#ffffff"
			d="M191,122.9v20.1h-4v-48.4h16.7c5.1,0,9,1.3,11.8,3.9,2.8,2.6,4.2,6,4.2,10.3s-1.4,7.8-4.2,10.3c-2.8,2.6-6.7,3.8-11.8,3.8h-12.7ZM191,119.5h12.7c4,0,7-1,9-3,2.1-2.1,3-4.6,3-7.7s-1-5.7-3-7.8c-2-2.1-5-3-9-3h-12.7v21.5Z"
		/>
		<path
			fill="#ffffff"
			d="M249,129.5h-21.2l-4.9,13.5h-4.1l17.8-48.4h3.7l17.7,48.4h-4.1l-4.8-13.5ZM229,126h18.7l-9.2-25.7h-.2l-9.3,25.7Z"
		/>
		<path
			fill="#ffffff"
			d="M138,209.8c0-2.5-1-4.6-2.9-6.2-2-1.6-5.4-3.1-10-4.6-5.2-1.4-9.1-3.2-11.8-5.3-2.7-2.1-4-5-4-8.7s1.5-6.8,4.6-9.1c3-2.4,6.9-3.6,11.5-3.6s8.8,1.3,11.9,4c3,2.7,4.5,6.1,4.4,10.3v.2h-3.8c0-3.2-1.2-5.8-3.5-7.9-2.3-2.1-5.3-3.1-8.9-3.1s-6.7.9-8.8,2.7c-2.1,1.8-3.2,4-3.2,6.6s1,4.5,2.9,6.1c2,1.6,5.4,3,10.3,4.5,5.1,1.5,9,3.3,11.7,5.4,2.7,2.1,4,5.1,4,8.7s-1.6,6.8-4.7,9.1c-3.1,2.3-7.1,3.5-11.9,3.5s-8.9-1.2-12.5-3.7c-3.6-2.4-5.3-6-5.2-10.6v-.2h3.7c0,3.7,1.4,6.5,4.2,8.4,2.9,1.8,6.1,2.8,9.6,2.8s6.7-.8,9-2.5c2.3-1.9,3.5-4.1,3.5-6.8Z"
		/>
		<path
			fill="#ffffff"
			d="M186.6,201.4c0,6.2-1.7,11.3-5.2,15.2-3.4,3.8-8,5.8-13.7,5.8s-10.2-2-13.6-5.8c-3.4-3.8-5.1-8.9-5.1-15.2v-7.9c0-6.2,1.7-11.2,5.1-15.2,3.4-3.8,7.9-5.8,13.6-5.8s10.4,2,13.8,5.8c3.4,3.8,5.2,8.9,5.2,15.2v7.9h0ZM182.7,193.4c0-5.3-1.3-9.5-4-12.7-2.7-3.2-6.3-4.8-11-4.8s-8.2,1.6-10.8,4.8-3.8,7.4-3.8,12.7v7.9c0,5.3,1.2,9.5,3.8,12.7,2.6,3.2,6.2,4.8,10.8,4.8s8.4-1.6,11-4.7c2.6-3.2,3.9-7.4,3.9-12.7v-8h0Z"
		/>
		<path
			fill="#ffffff"
			d="M229.6,206.5v.2c.2,4.7-1.3,8.6-4.6,11.3-3.2,2.9-7.4,4.3-12.6,4.3s-9.7-2-13-5.8c-3.3-3.8-4.9-8.9-4.9-15.1v-7.9c0-6.2,1.6-11.2,4.9-15.1,3.3-3.9,7.7-5.9,13-5.9s9.5,1.4,12.6,4.2c3.1,2.8,4.7,6.6,4.6,11.4v.2h-3.8c0-3.9-1.2-7-3.6-9.1-2.4-2.1-5.7-3.3-9.8-3.3s-7.6,1.6-10.2,4.9c-2.6,3.3-3.8,7.5-3.8,12.6v7.9c0,5.2,1.2,9.4,3.8,12.7,2.6,3.3,6,4.9,10.2,4.9s7.5-1.1,9.8-3.2c2.4-2.1,3.6-5.2,3.6-9.3h3.7Z"
		/>
		<path fill="#ffffff" d="M262.1,159.2H77.6c-.3,0-.4-.2-.4-.4s.2-.4.4-.4h184.5c.3,0,.4.2.4.4s-.2.4-.4.4Z" />
		<path
			fill="#ffffff"
			d="M107.8,249.6c0-.2-.2-.5-.3-1-.7.8-1.6,1.2-2.7,1.2s-1.7-.3-2.2-.8c-.6-.5-.9-1.2-.9-2s.4-1.7,1.1-2.2c.7-.5,1.8-.8,3.1-.8h1.5v-.7c0-.5-.2-1-.5-1.3s-.8-.5-1.5-.5-1.1.2-1.4.4c-.4.3-.5.6-.5,1.1h-1.6c0-.4.2-.9.5-1.3.4-.4.8-.8,1.3-1.1.5-.3,1.2-.4,1.9-.4,1.1,0,1.9.3,2.5.8.6.5.9,1.2,1,2.2v4.3c0,.9,0,1.5.4,2.1v.2h-1.6ZM105.2,248.4c.5,0,1,0,1.4-.4.4-.3.8-.6,1-1v-1.9h-1.2c-2,0-2.9.5-2.9,1.7s.2.9.5,1.2c.3.3.7.4,1.2.4Z"
		/>
		<path
			fill="#ffffff"
			d="M111.2,237.9c0-.3,0-.4.3-.6.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.6s0,.4-.3.6c-.2.2-.4.3-.7.3s-.5,0-.7-.3c-.2-.2-.3-.4-.3-.6ZM112.9,249.6h-1.6v-9.4h1.6v9.4Z"
		/>
		<path
			fill="#ffffff"
			d="M118.8,248.5c.5,0,1.1-.2,1.5-.5.4-.4.6-.8.7-1.2h1.5c0,.5-.2,1.1-.5,1.5-.4.4-.8.9-1.3,1.2s-1.2.4-1.8.4c-1.2,0-2.3-.4-3-1.2-.7-.9-1.2-2-1.2-3.5v-.3c0-.9.2-1.7.5-2.4.4-.7.8-1.2,1.4-1.6.6-.4,1.3-.6,2.2-.6s1.9.4,2.6,1c.7.6,1.1,1.4,1.1,2.4h-1.5c0-.6-.3-1.1-.7-1.5-.4-.4-.9-.6-1.5-.6s-1.4.3-1.9.9c-.4.6-.6,1.4-.6,2.5v.3c0,1.1.2,1.9.6,2.5.4.6,1.1.9,1.9.9Z"
		/>
		<path
			fill="#ffffff"
			d="M131.8,245.1c0,1.4-.4,2.6-1,3.4-.6.9-1.5,1.3-2.7,1.3s-2.1-.4-2.7-1.1v4.5h-1.6v-12.9h1.4v1.1c.7-.8,1.6-1.2,2.8-1.2s2,.4,2.7,1.2c.6.8,1,2.1,1,3.6v.2h0ZM130.1,244.9c0-1.1-.3-1.9-.7-2.5-.4-.6-1.1-.9-1.9-.9s-1.7.4-2.1,1.2v4.5c.4.9,1.2,1.2,2.2,1.2s1.3-.3,1.8-.9c.4-.6.7-1.5.7-2.7Z"
		/>
		<path
			fill="#ffffff"
			d="M139.1,249.6c0-.2-.2-.5-.3-1-.7.8-1.6,1.2-2.7,1.2s-1.7-.3-2.2-.8c-.6-.5-.9-1.2-.9-2s.4-1.7,1.1-2.2c.7-.5,1.8-.8,3.1-.8h1.5v-.7c0-.5-.2-1-.5-1.3-.4-.4-.8-.5-1.5-.5s-1.1.2-1.4.4c-.4.3-.5.6-.5,1.1h-1.6c0-.4.2-.9.5-1.3.4-.4.8-.8,1.3-1.1.5-.3,1.2-.4,1.9-.4,1.1,0,1.9.3,2.5.8.6.5.9,1.2,1,2.2v4.3c0,.9,0,1.5.4,2.1v.2h-1.6ZM136.4,248.4c.5,0,1,0,1.4-.4.4-.3.8-.6,1-1v-1.9h-1.2c-2,0-2.9.5-2.9,1.7s.2.9.5,1.2c.4.3.8.4,1.2.4Z"
		/>
		<path
			fill="#ffffff"
			d="M142.6,248.8c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3s.5,0,.7.3.3.4.3.7,0,.4-.3.6c-.2.2-.4.3-.7.3s-.5,0-.7-.3c-.2-.2-.3-.4-.3-.6Z"
		/>
		<path
			fill="#ffffff"
			d="M146.3,244.9c0-.9.2-1.7.5-2.5.4-.8.9-1.2,1.5-1.7.6-.4,1.3-.6,2.2-.6s2.3.4,3.1,1.3c.8.9,1.2,2.1,1.2,3.5h0c0,1-.2,1.8-.5,2.5-.4.7-.8,1.2-1.5,1.7-.6.4-1.4.6-2.2.6-1.2,0-2.3-.4-3-1.3-.8-.9-1.2-2.1-1.2-3.5h0ZM147.9,245.1c0,1.1.3,1.9.7,2.5.4.6,1.2,1,2,1s1.4-.4,2-1c.5-.6.7-1.5.7-2.7s-.3-1.9-.7-2.5c-.4-.6-1.2-1-2-1s-1.4.4-1.9,1c-.4.6-.8,1.5-.8,2.7Z"
		/>
		<path
			fill="#ffffff"
			d="M160.8,241.8c-.3,0-.5,0-.8,0-1.1,0-1.8.4-2.1,1.3v6.6h-1.6v-9.4h1.5v1.1c.5-.8,1.2-1.2,2.2-1.2s.5,0,.7,0v1.6h0Z"
		/>
		<path
			fill="#ffffff"
			d="M161.3,244.9c0-1.4.4-2.6,1-3.5.7-.9,1.6-1.2,2.7-1.2s2.1.4,2.7,1.2v-1.1h1.5v9.1c0,1.2-.4,2.1-1.1,2.9-.7.7-1.7,1.1-2.9,1.1s-1.3-.2-2-.4-1.2-.7-1.5-1.2l.8-1c.7.8,1.5,1.2,2.5,1.2s1.3-.2,1.8-.6c.4-.4.6-1.1.6-1.9v-.8c-.6.7-1.5,1.1-2.6,1.1s-2-.4-2.7-1.3c-.5-.9-.9-2.1-.9-3.6ZM162.9,245.1c0,1.1.2,1.9.6,2.5.4.6,1.1.9,1.8.9s1.8-.4,2.2-1.3v-4.3c-.4-.9-1.2-1.3-2.2-1.3s-1.3.3-1.8.9c-.4.6-.6,1.5-.6,2.7Z"
		/>
		<polygon fill="#ffffff" points="171.5 250.7 170.1 250.7 175.4 237.1 176.7 237.1 171.5 250.7" />
		<path
			fill="#ffffff"
			d="M183.4,247.1c0-.4-.2-.8-.4-1-.4-.3-.9-.4-1.7-.6-.8-.2-1.4-.4-2-.6-.4-.3-.8-.5-1.1-.9-.3-.4-.4-.7-.4-1.2,0-.8.4-1.4,1-2,.6-.5,1.5-.8,2.5-.8s1.9.3,2.6.8c.6.5,1,1.2,1,2.1h-1.6c0-.4-.2-.8-.5-1.2-.4-.4-.8-.4-1.4-.4s-1.1,0-1.3.4c-.4.3-.5.6-.5,1s.2.7.4.9c.3.2.9.4,1.7.5.8.2,1.4.4,2,.6.5.3.9.5,1.1.9.2.4.4.8.4,1.2,0,.8-.4,1.5-1,2-.6.5-1.5.7-2.6.7s-1.4,0-2-.4-1-.6-1.3-1.1c-.4-.4-.4-1-.4-1.5h1.6c0,.5.3,1,.6,1.2.4.3.9.4,1.6.4s1.1,0,1.4-.4c.4-.3.4-.4.4-.8Z"
		/>
		<path
			fill="#ffffff"
			d="M186.3,244.9c0-.9.2-1.7.5-2.5.4-.8.9-1.2,1.5-1.7.6-.4,1.3-.6,2.2-.6s2.3.4,3.1,1.3c.8.9,1.2,2.1,1.2,3.5h0c0,1-.2,1.8-.5,2.5-.4.7-.8,1.2-1.5,1.7-.6.4-1.4.6-2.2.6-1.2,0-2.3-.4-3-1.3-.8-.9-1.2-2.1-1.2-3.5h0ZM187.9,245.1c0,1.1.3,1.9.7,2.5.4.6,1.2,1,2,1s1.4-.4,2-1c.5-.6.7-1.5.7-2.7s-.3-1.9-.7-2.5c-.4-.6-1.2-1-2-1s-1.4.4-1.9,1c-.4.6-.8,1.5-.8,2.7Z"
		/>
		<path
			fill="#ffffff"
			d="M200,248.5c.5,0,1.1-.2,1.5-.5.4-.4.6-.8.7-1.2h1.5c0,.5-.2,1.1-.5,1.5-.4.4-.8.9-1.3,1.2-.5.3-1.2.4-1.8.4-1.2,0-2.3-.4-3-1.2-.7-.9-1.2-2-1.2-3.5v-.3c0-.9.2-1.7.5-2.4.4-.7.8-1.2,1.4-1.6.6-.4,1.3-.6,2.2-.6s1.9.4,2.6,1c.7.6,1.1,1.4,1.1,2.4h-1.5c0-.6-.3-1.1-.7-1.5-.4-.4-.9-.6-1.5-.6s-1.4.3-1.9.9c-.4.6-.6,1.4-.6,2.5v.3c0,1.1.2,1.9.6,2.5.4.6,1.1.9,1.9.9Z"
		/>
		<path
			fill="#ffffff"
			d="M211.7,245.5h1.8v1.3h-1.8v2.9h-1.6v-2.9h-5.7v-1l5.6-8.7h1.7v8.4ZM206.2,245.5h3.9v-6.2l-.2.4-3.7,5.8Z"
		/>
		<path
			fill="#ffffff"
			d="M220,247.1c0-.4-.2-.8-.4-1-.3-.2-.9-.4-1.7-.6-.8-.2-1.4-.4-2-.6-.4-.3-.8-.5-1.1-.9-.3-.4-.4-.7-.4-1.2,0-.8.4-1.4,1-2,.6-.5,1.5-.8,2.5-.8s1.9.3,2.6.8c.6.5,1,1.2,1,2.1h-1.6c0-.4-.2-.8-.5-1.2-.4-.4-.8-.4-1.4-.4s-1.1,0-1.3.4c-.4.3-.5.6-.5,1s.2.7.4.9c.3.2.9.4,1.7.5.8.2,1.4.4,2,.6.5.3.9.5,1.1.9s.4.8.4,1.2c0,.8-.4,1.5-1,2-.6.5-1.5.7-2.6.7s-1.4,0-2-.4-1-.6-1.3-1.1c-.4-.4-.4-1-.4-1.5h1.6c0,.5.3,1,.6,1.2.4.4.9.4,1.6.4s1.1,0,1.4-.4c.4-.3.4-.4.4-.8Z"
		/>
		<path
			fill="#ffffff"
			d="M222.8,244.9c0-.9.2-1.7.5-2.5.4-.7.9-1.2,1.5-1.7.6-.4,1.3-.6,2.2-.6s2.3.4,3.1,1.3c.8.9,1.2,2.1,1.2,3.5h0c0,1-.2,1.8-.5,2.5s-.8,1.2-1.5,1.7c-.6.4-1.4.6-2.2.6-1.2,0-2.3-.4-3-1.3-.8-.9-1.2-2.1-1.2-3.5h0ZM224.4,245.1c0,1.1.3,1.9.7,2.5.4.6,1.2,1,2,1s1.4-.4,2-1c.4-.6.7-1.5.7-2.7s-.3-1.9-.7-2.5c-.4-.6-1.2-1-2-1s-1.4.4-1.9,1c-.4.6-.8,1.5-.8,2.7Z"
		/>
	</svg>
)
export default SvgSyAicpa
